import { ChipDesignTokens } from '@primeuix/themes/types/chip';

export const chipPreset: ChipDesignTokens = {
  root: {
    borderRadius: '{borderRadius}',
  },
  colorScheme: {
    dark: {
      root: {
        background: '{nspSky.700}',
        color: '{nspSlate.0}',
      },
      icon: {
        color: '{nspSlate.0}',
      },
      removeIcon: {
        color: '{nspSlate.0}',
      },
    },
    light: {
      root: {
        background: '{nspSky.700}',
        color: '{nspSlate.0}',
      },
      icon: {
        color: '{nspSlate.0}',
      },
      removeIcon: {
        color: '{nspSlate.0}',
      },
    },
  },
};
